import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";

const ViewDocumentAttachments = ({documentDetail}) => {

    const [attachmentData, setAttachmentData] = useState([]) 

  useEffect(()=>{
 console.log(documentDetail)
        const attachments = documentDetail?.attachments
        setAttachmentData(attachments) 
  },[documentDetail])  

  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };


  return (
    <>
      <div style={{
        borderTop: "1px solid #e5e7eb",
        paddingTop: "16px",
        marginTop: "16px"
      }}>
        <div style={{ 
          fontSize: "14px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "12px",
          display: "flex",
          alignItems: "center",
          gap: "6px"
        }}>
          <i className="fa-solid fa-paperclip" style={{ color: "#6b7280", fontSize: "14px" }}></i>
          Attachments ({documentDetail?.attachments?.length || 0})
        </div>
        
            {attachmentData?.length > 0 ? (
          <div className="row g-2">
            {attachmentData.map((item, index) => (
              <div key={item.id} className="col-md-4 col-sm-6 col-12">
                <ListItem
                id={item.id}
                item={item}
                download={handleDownloadAll}
                />
              </div>
            ))}
          </div>
                    ) : (
          <div style={{
            padding: "24px 16px",
            textAlign: "center",
            background: "#f9fafb",
            borderRadius: "6px",
            border: "1px dashed #e5e7eb"
          }}>
            <i className="fa-solid fa-paperclip" style={{ 
              fontSize: "32px", 
              color: "#d1d5db",
              marginBottom: "8px",
              display: "block"
            }}></i>
            <p style={{ 
              margin: 0, 
              fontSize: "13px",
              color: "#9ca3af"
            }}>
              No attachments available
            </p>
        </div>  
        )}
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />
    </>
  );
};

export const ListItem = ({ item, download }) => {
  const isPdf = item?.url?.split(".").pop()?.toLowerCase() === "pdf";
  const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(item?.url?.split(".").pop()?.toLowerCase());
  
  return (
    <div style={{
      background: "#ffffff",
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      overflow: "hidden",
      position: "relative",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
      e.currentTarget.style.transform = "translateY(-2px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = "none";
      e.currentTarget.style.transform = "translateY(0)";
    }}
    >
      <div style={{
        width: "100%",
        height: "140px",
        background: isPdf ? "#fee2e2" : "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative"
      }}>
        {isPdf ? (
          <i className="fa-solid fa-file-pdf" style={{ 
            fontSize: "48px", 
            color: "#dc2626" 
          }}></i>
        ) : isImage ? (
          <img 
            src={item.url} 
            alt={item.name || "Attachment"} 
            style={{ 
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }} 
          />
        ) : (
          <i className="fa-solid fa-file" style={{ 
            fontSize: "48px", 
            color: "#6b7280" 
          }}></i>
        )}
      </div>
      <div style={{
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "6px"
      }}>
        <div style={{ 
          flex: 1, 
          minWidth: 0,
          overflow: "hidden"
        }}>
          <div style={{ 
            fontSize: "11px", 
            color: "#374151",
            fontWeight: "500",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}>
            {item.name || "Attachment"}
          </div>
    </div>
        <div style={{ 
          display: "flex", 
          gap: "6px",
          flexShrink: 0
        }}>
          <Link 
            to={item?.url} 
            target="_blank" 
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "4px",
              background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              textDecoration: "none",
              boxShadow: "0 2px 4px rgba(211, 0, 26, 0.2)"
            }}
          >
            <i className="fa-solid fa-eye" style={{ fontSize: "12px" }}></i>
          </Link>
          <Link 
            to="#" 
            onClick={(e) => {
              e.preventDefault();
              download(item);
            }}
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "4px",
              background: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6b7280",
              textDecoration: "none",
              border: "1px solid #e5e7eb"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#e5e7eb";
              e.currentTarget.style.color = "#374151";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#f3f4f6";
              e.currentTarget.style.color = "#6b7280";
            }}
          >
            <i className="fa-solid fa-download" style={{ fontSize: "12px" }}></i>
        </Link>
        </div>
      </div>
    </div>
  );
};

export default ViewDocumentAttachments;
